import React from 'react';
import { motion } from 'framer-motion';

export const BentoGrid = ({ children, className = '' }) => {
  return (
    <div className={`grid grid-cols-1 md:grid-cols-4 gap-4 auto-rows-[180px] ${className}`}>
      {children}
    </div>
  );
};

export const BentoCard = ({ 
  children, 
  className = '', 
  colSpan = 'col-span-1', 
  rowSpan = 'row-span-1',
  delay = 0,
  dark = false
}) => {
  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1], delay } 
    }
  };

  return (
    <motion.div
      variants={cardVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-100px" }}
      className={`relative overflow-hidden rounded-[24px] p-6 transition-all duration-300 ${colSpan} ${rowSpan} ${
        dark 
          ? 'bg-[#121514] text-white border border-[rgba(255,255,255,0.05)]' 
          : 'bg-[#F0F4F9] text-gray-900 border border-[rgba(0,0,0,0.03)]'
      } ${className}`}
    >
      {children}
    </motion.div>
  );
};
